/**
 * Tilt Shop — Opening hours live indicator
 * Fills #tilt-opening-status (rendered by the custom-liquid section on the contact page).
 */
(function () {
  function run() {
    var el = document.getElementById('tilt-opening-status');
    if (!el) return;

    var now = new Date(new Date().toLocaleString('en-US', { timeZone: 'Africa/Johannesburg' }));
    var day = now.getDay();   // 0 = Sun, 6 = Sat
    var hour = now.getHours();
    var isOpen = day >= 1 && day <= 5 && hour >= 8 && hour < 16;

    el.textContent = isOpen ? 'We are open now' : 'We are currently closed';
    el.setAttribute('data-status', isOpen ? 'open' : 'closed');
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
})();
